import React from 'react';
import {
  SolutionPremiumContent,
  SolutionSubPageLayout,
  getSolutionSubpage,
} from '../features/solutions';

export const SmartCommercialLighting: React.FC = () => {
  const config = getSolutionSubpage('commercial-lighting');
  return (
    <SolutionSubPageLayout config={config}>
      <SolutionPremiumContent config={config} />
    </SolutionSubPageLayout>
  );
};
